"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.transformDistanceWithOptions = transformDistanceWithOptions;
var _MiscUtils = _interopRequireDefault(require("../MiscUtils"));
var _config = require("./config");
var _transformDistanceToUnits = _interopRequireDefault(require("./transformDistanceToUnits"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function transformDistanceWithOptions(distanceFromProps) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    FEET,
    KILOMETERS
  } = _config.UNITS.DISTANCE;
  const {
    roundTo = undefined,
    to = FEET,
    from = KILOMETERS
  } = options;
  let distance = distanceFromProps;
  distance = (0, _transformDistanceToUnits.default)(distance, from, to);
  if (roundTo !== undefined) {
    distance = _MiscUtils.default.roundToDigitPlace(distance, roundTo);
  }
  return distance;
}
var _default = transformDistanceWithOptions;
exports.default = _default;